import type { WorkOrdersSquare } from 'types/squares.type';
export const workOrdersToIgnore = [
  'UNSPECIFIED',
  'N.A.',
  'OTHERS',
  'Miscellaneous',
].map((x) => x.toLowerCase());

const normalize = (value?: string) => (value ?? '').trim().toLowerCase();

export function filterWorkOrders(workOrders: WorkOrdersSquare[]) {
  return workOrders.filter((item) => {
    const component = normalize(item.components_category);

    let subComponents: string[] = [];
    const rawSub = item.sub_component_categories || '';

    try {
      const parsed = JSON.parse(rawSub);
      subComponents = Array.isArray(parsed)
        ? parsed.map((s) => normalize(String(s)))
        : [normalize(String(parsed))];
    } catch {
      subComponents = [normalize(rawSub)];
    }

    const hasSub = (value: string) => subComponents.includes(value);

    const isNAComponentAndSub = component === 'n.a.' && hasSub('n.a.');

    const isUnspecifiedComponent = component === 'unspecified';

    const isUnspecifiedSub = hasSub('unspecified');

    const isMiscellaneousSub = hasSub('miscellaneous');

    const isOthersComponentAndSub = component === 'others' && hasSub('others');

    const shouldExclude =
      isNAComponentAndSub ||
      isUnspecifiedComponent ||
      isUnspecifiedSub ||
      isMiscellaneousSub ||
      isOthersComponentAndSub;

    return !shouldExclude;
  });
}

interface CategoryItem {
  name?: string;
  [key: string]: any;
}

export function filterWorkOrdersByName<T extends CategoryItem>(data: T[]): T[] {
  if (!Array.isArray(data)) return [];

  return data.filter((item) => {
    if (!item?.name) return true;

    return !workOrdersToIgnore.includes(item.name.toLowerCase());
  });
}
